// Lightweight, opt-in debug logger. Emits only when the `aiAssistantDebug`
// flag is set in localStorage, so production stays free of console output
// (CLAUDE.md A3 — no console.log in production).
//
// Enable in the task pane console with:
//   localStorage.aiAssistantDebug = "1"
// Disable with:
//   delete localStorage.aiAssistantDebug

export function isDebugEnabled(): boolean {
  try {
    return localStorage.getItem("aiAssistantDebug") === "1";
  } catch {
    return false;
  }
}

export function debugLog(scope: string, data: unknown): void {
  if (!isDebugEnabled()) return;
  console.log(`[ai-assistant:${scope}]`, data);
}
